(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ai_gen_block_93e3962"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function runCounter(el) {
      var raw = el.getAttribute('data-agc-count');
      var target = parseFloat(String(raw).replace(/,/g, ''));
      if (isNaN(target) || reduce) return;
      var start = null;
      var duration = 1800;
      function step(ts) {
        if (start === null) start = ts;
        if (!el.isConnected) return;
        if (document.hidden) { el.textContent = Math.round(target).toLocaleString(); return; }
        var p = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = Math.round(target * eased).toLocaleString();
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = Math.round(target).toLocaleString();
      }
      el.textContent = '0';
      requestAnimationFrame(step);
    }

    /* Build the two scrolling rows from the single set of tiles in the HTML.
       Only as many copies as the row width needs (always an even number so the
       -50% loop is seamless). */
    function setupMarquee(root, cleanups) {
      var rows = Array.from(root.querySelectorAll('.agc__row'));
      var source = root.querySelector('.agc__set[data-agc-source]');
      if (!source || !rows.length) return;

      var seen = new Set();
      var photos = Array.from(source.children).filter(function (tile) {
        var img = tile.querySelector('img');
        if (!img) return true;
        var key = (img.getAttribute('src') || '').split('?')[0];
        if (!key) return true;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
      for (var i = photos.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = photos[i]; photos[i] = photos[j]; photos[j] = temp;
      }
      var groups = rows.map(function () { return []; });
      photos.forEach(function (photo, index) {
        groups[index % rows.length].push(photo);
      });

      function makeSet(group, hidden) {
        var set = document.createElement('div');
        set.className = 'agc__set';
        if (hidden) set.setAttribute('aria-hidden', 'true');
        group.forEach(function (photo) { set.appendChild(photo.cloneNode(true)); });
        return set;
      }

      function build() {
        rows.forEach(function (row, idx) {
          var group = groups[idx];
          var track = row.querySelector('.agc__track');
          if (!track) return;
          if (!group.length) {
            row.hidden = true;
            row.style.display = 'none';
            return;
          }
          var existing = track.firstElementChild;
          if (existing) {
            var existingWidth = existing.getBoundingClientRect().width;
            if (existingWidth > 0 && row.__agcHalf === Math.max(1, Math.ceil(row.clientWidth / existingWidth))) return;
          }
          var probe = makeSet(group, false);
          track.replaceChildren(probe);
          var setWidth = probe.getBoundingClientRect().width;
          var rowWidth = row.clientWidth || window.innerWidth;
          var half = setWidth > 0 ? Math.max(1, Math.ceil(rowWidth / setWidth)) : 2;
          for (var c = 1; c < half * 2; c++) {
            track.appendChild(makeSet(group, true));
          }
          row.__agcHalf = half;
        });
      }
      build();

      var resizeTimer = null;
      var lastWidth = window.innerWidth;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          build();
        }, 250);
      }
      window.addEventListener('resize', onResize, { passive: true });
      cleanups.push(function () { clearTimeout(resizeTimer); window.removeEventListener('resize', onResize); });
    }

    function initAgc(root) {
      if (!root || root.getAttribute('data-agc-ready')) return;
      root.setAttribute('data-agc-ready', '1');

      var cleanups = [];
      var frames = new Set();
      function frame(fn) {
        var id = requestAnimationFrame(function (ts) {
          frames.delete(id);
          if (root.isConnected) fn(ts);
        });
        frames.add(id);
        return id;
      }
      function cancelFrame(id) { cancelAnimationFrame(id); frames.delete(id); }
      root.__agcCleanup = function () {
        cleanups.forEach(function (fn) { fn(); });
        frames.forEach(cancelAnimationFrame);
        frames.clear();
        root.removeAttribute('data-agc-ready');
        delete root.__agcCleanup;
      };
      setupMarquee(root, cleanups);

      var reveals = root.querySelectorAll('.agc__reveal');
      var counters = root.querySelectorAll('[data-agc-count]');
      var visibleHandlers = [];

      function showAll() {
        root.classList.add('is-in');
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      }

      if (!('IntersectionObserver' in window) || reduce) {
        showAll();
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            if (el === root) {
              root.classList.add('is-in');
            } else if (el.hasAttribute('data-agc-count')) {
              runCounter(el);
            } else {
              el.classList.add('is-visible');
            }
            io.unobserve(el);
          });
        }, { threshold: 0.15 });

        io.observe(root);
        reveals.forEach(function (el) { io.observe(el); });
        counters.forEach(function (el) { io.observe(el); });

        cleanups.push(function () { io.disconnect(); });
      }

      var inViewport = true;
      var sectionActive = !document.hidden;
      function syncVisibility() {
        sectionActive = inViewport && !document.hidden;
        root.classList.toggle('is-off', !sectionActive);
        visibleHandlers.forEach(function (fn) { fn(sectionActive); });
      }
      document.addEventListener('visibilitychange', syncVisibility);
      cleanups.push(function () { document.removeEventListener('visibilitychange', syncVisibility); });
      if ('IntersectionObserver' in window) {
        /* Pause animation and pointer/scroll work outside the viewport. */
        var offIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            inViewport = entry.isIntersecting;
            syncVisibility();
          });
        }, { rootMargin: '0px' });
        offIo.observe(root);
        cleanups.push(function () { offIo.disconnect(); });
      }

      /* Cursor spotlight on glass cards (throttled to one write per frame) */
      if (!reduce && canHover) root.querySelectorAll('[data-agc-spot]').forEach(function (card) {
        var pending = false, px = 0, py = 0;
        card.addEventListener('pointermove', function (e) {
          if (!sectionActive) return;
          px = e.clientX; py = e.clientY;
          if (pending) return;
          pending = true;
          frame(function () {
            pending = false;
            if (!sectionActive) return;
            var r = card.getBoundingClientRect();
            card.style.setProperty('--mx', (px - r.left) + 'px');
            card.style.setProperty('--my', (py - r.top) + 'px');
          });
        }, { passive: true });
      });

      var btn = root.querySelector('[data-agc-magnet]');
      if (btn && !reduce && canHover) {
        var buttonFrame = null, buttonX = 0, buttonY = 0;
        var anchor = btn.closest('.agc__btn-wrap') || btn;
        function resetButton() {
          cancelFrame(buttonFrame); buttonFrame = null;
          btn.style.transform = '';
        }
        btn.addEventListener('pointermove', function (e) {
          if (!sectionActive) return;
          buttonX = e.clientX; buttonY = e.clientY;
          if (buttonFrame !== null) return;
          buttonFrame = frame(function () {
            buttonFrame = null;
            if (!sectionActive) return;
            var r = anchor.getBoundingClientRect();
            var x = (buttonX - r.left - r.width / 2) * 0.18;
            var y = (buttonY - r.top - r.height / 2) * 0.28;
            btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
          });
        }, { passive: true });
        btn.addEventListener('pointerleave', resetButton);
        visibleHandlers.push(function (visible) { if (!visible) resetButton(); });
      }

      /* Soft light that follows the cursor: one rect read per frame */
      var glow = root.querySelector('.agc__glow');
      if (glow && !reduce && canHover) {
        var mx = 0, my = 0, tx = 0, ty = 0, cx = 0, cy = 0, raf = null, active = false;
        var loop = function () {
          raf = null;
          if (!sectionActive) return;
          var r = root.getBoundingClientRect();
          tx = mx - r.left; ty = my - r.top;
          if (!active) { cx = tx; cy = ty; active = true; glow.style.opacity = '1'; }
          cx += (tx - cx) * 0.12;
          cy += (ty - cy) * 0.12;
          glow.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0)';
          if (Math.abs(tx - cx) > 0.5 || Math.abs(ty - cy) > 0.5) raf = frame(loop);
        };
        root.addEventListener('pointermove', function (e) {
          if (!sectionActive) return;
          mx = e.clientX; my = e.clientY;
          if (!raf) raf = frame(loop);
        }, { passive: true });
        function stopGlow() { cancelFrame(raf); raf = null; active = false; glow.style.opacity = '0'; }
        root.addEventListener('pointerleave', stopGlow);
        visibleHandlers.push(function (visible) { if (!visible) stopGlow(); });
      }

      /* Watermark parallax: writes transform straight to the element (no custom
         property on the root, so no re-styling of every photo) and only listens
         while the section is on screen. */
      var mark = root.querySelector('.agc__mark');
      if (mark && !reduce) {
        var ticking = false;
        var attached = false;
        var update = function () {
          ticking = false;
          if (!sectionActive) return;
          var r = root.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          p = Math.max(-1.2, Math.min(1.2, p));
          mark.style.transform = 'translate3d(' + (p * -140).toFixed(1) + 'px,0,0)';
        };
        var onScroll = function () {
          if (!ticking) { ticking = true; frame(update); }
        };
        var toggle = function (visible) {
          if (visible && !attached) {
            attached = true;
            window.addEventListener('scroll', onScroll, { passive: true });
            update();
          } else if (!visible && attached) {
            attached = false;
            window.removeEventListener('scroll', onScroll);
          }
        };
        visibleHandlers.push(toggle);
        if (!('IntersectionObserver' in window)) toggle(!document.hidden);
        cleanups.push(function () { toggle(false); });
      }
      syncVisibility();
    }

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      if (e.target.__agcCleanup) e.target.__agcCleanup();
      e.target.querySelectorAll('[data-agc]').forEach(function (root) {
        if (root.__agcCleanup) root.__agcCleanup();
      });
    });

    function initAll() {
      document.querySelectorAll('[data-agc]').forEach(initAgc);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    /* Theme editor: re-run when the block or its section is added or edited */
    function onEditorLoad(e) {
      var t = e.target;
      if (!t || !t.querySelector) return;
      var el = t.matches && t.matches('[data-agc]') ? t : t.querySelector('[data-agc]');
      if (el) initAgc(el);
    }
    document.addEventListener('shopify:section:load', onEditorLoad);
    document.addEventListener('shopify:block:select', onEditorLoad);
    document.addEventListener('shopify:block:load', onEditorLoad);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_b3f8c80"] && !Shopify.designMode) return;
  try {
    (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    /* ============ GALLERY VIEWER ============ */
    function setupLightbox(root, cleanups) {
      var lb = root.querySelector('[data-agg-lb]');
      var source = root.querySelector('.agg__set[data-agg-source]');
      if (!lb || !source) return;

      /* read the photo list BEFORE the marquee rebuilds (and removes) the source tiles */
      var slides = Array.from(source.querySelectorAll('.agg__tile[data-full]')).map(function (t) {
        var im = t.querySelector('img');
        return { full: t.getAttribute('data-full'), thumb: t.getAttribute('data-thumb') || t.getAttribute('data-full'), cap: t.getAttribute('data-cap') || '', alt: im ? im.getAttribute('alt') || '' : '' };
      });
      var n = slides.length;
      var openBtn = root.querySelector('[data-agg-open]');
      if (!n) { if (openBtn) openBtn.disabled = true; return; }

      /* move the viewer to <body>; clear any old copy from a previous init (theme editor) */
      var blockId = lb.getAttribute('data-agg-lb-for');
      document.querySelectorAll('[data-agg-lb-for="' + blockId + '"]').forEach(function (old) { if (old !== lb) old.remove(); });
      document.body.appendChild(lb);
      root.__aggLb = lb;

      var img = lb.querySelector('[data-lb-img]');
      var fig = lb.querySelector('[data-lb-fig]');
      var capEl = lb.querySelector('[data-lb-cap]');
      var cur = lb.querySelector('[data-lb-cur]');
      var total = lb.querySelector('[data-lb-total]');
      var thumbsEl = lb.querySelector('[data-lb-thumbs]');
      var closeBtn = lb.querySelector('.agg-lb__close');
      var idx = 0, isOpen = false, token = 0, lastFocus = null, closeTimer = null, touchX = null, touchY = null;
      var pad = function (v) { return (v < 10 ? '0' : '') + v; };

      total.textContent = pad(n);
      if (n < 2) { lb.querySelectorAll('[data-lb-prev], [data-lb-next]').forEach(function (b) { b.style.display = 'none'; }); thumbsEl.style.display = 'none'; }

      var thumbs = slides.map(function (s, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'agg-lb__thumb';
        b.setAttribute('aria-label', 'Show photo ' + (i + 1));
        var t = document.createElement('img');
        t.src = s.thumb; t.alt = ''; t.loading = 'lazy'; t.decoding = 'async';
        b.appendChild(t);
        b.addEventListener('click', function () { go(i, i > idx ? 1 : -1); });
        thumbsEl.appendChild(b);
        return b;
      });

      function zoom(on) {
        lb.classList.toggle('is-zoomed', !!on);
        if (!on) { img.style.removeProperty('--zx'); img.style.removeProperty('--zy'); }
      }

      function preload(i) { var im = new Image(); im.src = slides[(i + n) % n].full; }

      function go(i, dir) {
        idx = (i + n) % n;
        var s = slides[idx];
        var my = ++token;
        zoom(false);
        lb.classList.add('is-loading');
        var pre = new Image();
        var done = function () {
          if (my !== token) return;
          img.src = s.full;
          img.alt = s.alt;
          capEl.textContent = s.cap;
          capEl.hidden = !s.cap;
          lb.classList.remove('is-loading');
          img.classList.remove('agg-in-fade', 'agg-in-next', 'agg-in-prev');
          void img.offsetWidth;
          img.classList.add(dir > 0 ? 'agg-in-next' : dir < 0 ? 'agg-in-prev' : 'agg-in-fade');
        };
        pre.onload = done; pre.onerror = done;
        pre.src = s.full;
        cur.textContent = pad(idx + 1);
        thumbs.forEach(function (b, k) { b.classList.toggle('is-active', k === idx); if (k === idx) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
        var active = thumbs[idx];
        if (active && active.scrollIntoView) active.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce || !isOpen ? 'auto' : 'smooth' });
        if (n > 1) { preload(idx + 1); preload(idx - 1); }
      }

      function onKey(e) {
        if (!isOpen) return;
        if (e.key === 'Escape') { e.preventDefault(); close(); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); if (n > 1) go(idx + 1, 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); if (n > 1) go(idx - 1, -1); }
        else if (e.key === 'Home') { e.preventDefault(); go(0, -1); }
        else if (e.key === 'End') { e.preventDefault(); go(n - 1, 1); }
        else if (e.key === 'Tab') {
          var f = Array.from(lb.querySelectorAll('button:not([disabled])')).filter(function (el) { return el.offsetParent !== null; });
          if (!f.length) return;
          var first = f[0], last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
          else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      }

      function open(start) {
        if (isOpen) return;
        clearTimeout(closeTimer);
        isOpen = true;
        lastFocus = document.activeElement;
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        if (sbw > 0) document.body.style.paddingRight = sbw + 'px';
        document.documentElement.classList.add('agg-lock');
        lb.hidden = false;
        void lb.offsetWidth;
        lb.classList.add('is-open');
        go(start || 0, 0);
        document.addEventListener('keydown', onKey);
        setTimeout(function () { if (closeBtn) closeBtn.focus({ preventScroll: true }); }, 30);
      }

      function close() {
        if (!isOpen) return;
        isOpen = false;
        token++;
        lb.classList.remove('is-open', 'is-zoomed', 'is-loading');
        document.removeEventListener('keydown', onKey);
        closeTimer = setTimeout(function () {
          lb.hidden = true;
          document.documentElement.classList.remove('agg-lock');
          document.body.style.paddingRight = '';
        }, reduce ? 0 : 420);
        if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
      }

      /* open from the button or from any photo (event delegation covers the cloned rows) */
      function onRootClick(e) {
        var btn = e.target.closest && e.target.closest('[data-agg-open]');
        if (btn && root.contains(btn)) { open(0); return; }
        var tile = e.target.closest && e.target.closest('.agg__tile[data-agg-index]');
        if (tile && root.contains(tile)) open(parseInt(tile.getAttribute('data-agg-index'), 10) || 0);
      }
      root.addEventListener('click', onRootClick);

      lb.addEventListener('click', function (e) {
        if (e.target.closest('[data-lb-close]')) { close(); return; }
        if (e.target.closest('[data-lb-prev]')) { go(idx - 1, -1); return; }
        if (e.target.closest('[data-lb-next]')) { go(idx + 1, 1); return; }
        if (e.target === img) { zoom(!lb.classList.contains('is-zoomed')); return; }
        if (e.target === fig || e.target.hasAttribute && e.target.hasAttribute('data-lb-stage')) close();
      });

      /* pan while zoomed */
      fig.addEventListener('pointermove', function (e) {
        if (!lb.classList.contains('is-zoomed')) return;
        var r = fig.getBoundingClientRect();
        img.style.setProperty('--zx', Math.max(0, Math.min(100, ((e.clientX - r.left) / r.width) * 100)).toFixed(1) + '%');
        img.style.setProperty('--zy', Math.max(0, Math.min(100, ((e.clientY - r.top) / r.height) * 100)).toFixed(1) + '%');
      }, { passive: true });

      /* swipe */
      lb.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { touchX = null; return; }
        touchX = e.touches[0].clientX; touchY = e.touches[0].clientY;
      }, { passive: true });
      lb.addEventListener('touchend', function (e) {
        if (touchX === null || lb.classList.contains('is-zoomed')) { touchX = null; return; }
        var t = e.changedTouches[0];
        var dx = t.clientX - touchX, dy = t.clientY - touchY;
        touchX = null;
        if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.4 && n > 1) go(idx + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
        else if (dy > 90 && Math.abs(dy) > Math.abs(dx) * 1.6) close();
      }, { passive: true });

      cleanups.push(function () {
        root.removeEventListener('click', onRootClick);
        document.removeEventListener('keydown', onKey);
        clearTimeout(closeTimer);
        if (isOpen) { document.documentElement.classList.remove('agg-lock'); document.body.style.paddingRight = ''; }
        lb.remove();
      });
    }

    /* ============ PHOTO ROWS ============ */
    function setupMarquee(root, cleanups) {
      var rows = Array.from(root.querySelectorAll('.agg__row'));
      var source = root.querySelector('.agg__set[data-agg-source]');
      if (!source || !rows.length) return;

      var photos = Array.from(source.children);
      var groups = rows.map(function () { return []; });
      photos.forEach(function (photo, index) { groups[index % rows.length].push(photo); });

      function makeSet(group, hidden) {
        var set = document.createElement('div');
        set.className = 'agg__set';
        if (hidden) set.setAttribute('aria-hidden', 'true');
        group.forEach(function (photo) { set.appendChild(photo.cloneNode(true)); });
        return set;
      }

      function build() {
        rows.forEach(function (row, idx) {
          var group = groups[idx];
          var track = row.querySelector('.agg__track');
          if (!track) return;
          if (!group.length) { row.hidden = true; row.style.display = 'none'; return; }
          var existing = track.firstElementChild;
          if (existing) {
            var existingWidth = existing.getBoundingClientRect().width;
            if (existingWidth > 0 && row.__aggHalf === Math.max(1, Math.ceil(row.clientWidth / existingWidth))) return;
          }
          var probe = makeSet(group, false);
          track.replaceChildren(probe);
          var setWidth = probe.getBoundingClientRect().width;
          var rowWidth = row.clientWidth || window.innerWidth;
          var half = setWidth > 0 ? Math.max(1, Math.ceil(rowWidth / setWidth)) : 2;
          for (var c = 1; c < half * 2; c++) track.appendChild(makeSet(group, true));
          row.__aggHalf = half;
        });
      }
      build();

      var resizeTimer = null;
      var lastWidth = window.innerWidth;
      function onResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (window.innerWidth === lastWidth) return;
          lastWidth = window.innerWidth;
          build();
        }, 250);
      }
      window.addEventListener('resize', onResize, { passive: true });
      cleanups.push(function () { clearTimeout(resizeTimer); window.removeEventListener('resize', onResize); });
    }

    /* ============ SECTION ============ */
    function initAgg(root) {
      if (!root || root.getAttribute('data-agg-ready')) return;
      root.setAttribute('data-agg-ready', '1');

      var cleanups = [];
      var frames = new Set();
      function frame(fn) {
        var id = requestAnimationFrame(function (ts) { frames.delete(id); if (root.isConnected) fn(ts); });
        frames.add(id);
        return id;
      }
      function cancelFrame(id) { cancelAnimationFrame(id); frames.delete(id); }
      root.__aggCleanup = function () {
        cleanups.forEach(function (fn) { fn(); });
        frames.forEach(cancelAnimationFrame);
        frames.clear();
        root.removeAttribute('data-agg-ready');
        delete root.__aggCleanup;
      };

      setupLightbox(root, cleanups);
      setupMarquee(root, cleanups);

      var reveals = root.querySelectorAll('.agg__reveal');
      var visibleHandlers = [];

      function showAll() {
        root.classList.add('is-in');
        reveals.forEach(function (el) { el.classList.add('is-visible'); });
      }

      if (!('IntersectionObserver' in window) || reduce) {
        showAll();
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            var el = entry.target;
            if (el === root) root.classList.add('is-in');
            else el.classList.add('is-visible');
            io.unobserve(el);
          });
        }, { threshold: 0.15 });
        io.observe(root);
        reveals.forEach(function (el) { io.observe(el); });
        cleanups.push(function () { io.disconnect(); });
      }

      var inViewport = true;
      var sectionActive = !document.hidden;
      function syncVisibility() {
        sectionActive = inViewport && !document.hidden;
        root.classList.toggle('is-off', !sectionActive);
        visibleHandlers.forEach(function (fn) { fn(sectionActive); });
      }
      document.addEventListener('visibilitychange', syncVisibility);
      cleanups.push(function () { document.removeEventListener('visibilitychange', syncVisibility); });
      if ('IntersectionObserver' in window) {
        var offIo = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) { inViewport = entry.isIntersecting; syncVisibility(); });
        }, { rootMargin: '0px' });
        offIo.observe(root);
        cleanups.push(function () { offIo.disconnect(); });
      }

      /* cursor spotlight on glass cards */
      if (!reduce && canHover) root.querySelectorAll('[data-agg-spot]').forEach(function (card) {
        var pending = false, px = 0, py = 0;
        card.addEventListener('pointermove', function (e) {
          if (!sectionActive) return;
          px = e.clientX; py = e.clientY;
          if (pending) return;
          pending = true;
          frame(function () {
            pending = false;
            if (!sectionActive) return;
            var r = card.getBoundingClientRect();
            card.style.setProperty('--mx', (px - r.left) + 'px');
            card.style.setProperty('--my', (py - r.top) + 'px');
          });
        }, { passive: true });
      });

      /* magnetic button */
      var btn = root.querySelector('[data-agg-magnet]');
      if (btn && !reduce && canHover) {
        var buttonFrame = null, buttonX = 0, buttonY = 0;
        var anchor = btn.closest('.agg__btn-wrap') || btn;
        var resetButton = function () { if (buttonFrame !== null) cancelFrame(buttonFrame); buttonFrame = null; btn.style.transform = ''; };
        btn.addEventListener('pointermove', function (e) {
          if (!sectionActive) return;
          buttonX = e.clientX; buttonY = e.clientY;
          if (buttonFrame !== null) return;
          buttonFrame = frame(function () {
            buttonFrame = null;
            if (!sectionActive) return;
            var r = anchor.getBoundingClientRect();
            var x = (buttonX - r.left - r.width / 2) * 0.18;
            var y = (buttonY - r.top - r.height / 2) * 0.28;
            btn.style.transform = 'translate(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px)';
          });
        }, { passive: true });
        btn.addEventListener('pointerleave', resetButton);
        visibleHandlers.push(function (visible) { if (!visible) resetButton(); });
      }

      /* watermark parallax (only listens while on screen) */
      var mark = root.querySelector('.agg__mark');
      if (mark && !reduce) {
        var ticking = false, attached = false;
        var update = function () {
          ticking = false;
          if (!sectionActive) return;
          var r = root.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          var p = (r.top + r.height / 2 - vh / 2) / vh;
          p = Math.max(-1.2, Math.min(1.2, p));
          mark.style.transform = 'translate3d(' + (p * -140).toFixed(1) + 'px,0,0)';
        };
        var onScroll = function () { if (!ticking) { ticking = true; frame(update); } };
        var toggle = function (visible) {
          if (visible && !attached) { attached = true; window.addEventListener('scroll', onScroll, { passive: true }); update(); }
          else if (!visible && attached) { attached = false; window.removeEventListener('scroll', onScroll); }
        };
        visibleHandlers.push(toggle);
        if (!('IntersectionObserver' in window)) toggle(!document.hidden);
        cleanups.push(function () { toggle(false); });
      }
      syncVisibility();
    }

    document.addEventListener('shopify:section:unload', function (e) {
      if (!e.target || !e.target.querySelectorAll) return;
      if (e.target.__aggCleanup) e.target.__aggCleanup();
      e.target.querySelectorAll('[data-agg]').forEach(function (root) { if (root.__aggCleanup) root.__aggCleanup(); });
    });

    function initAll() { document.querySelectorAll('[data-agg]').forEach(initAgg); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    function onEditorLoad(e) {
      var t = e.target;
      if (!t || !t.querySelector) return;
      var el = t.matches && t.matches('[data-agg]') ? t : t.querySelector('[data-agg]');
      if (el) initAgg(el);
    }
    document.addEventListener('shopify:section:load', onEditorLoad);
    document.addEventListener('shopify:block:select', onEditorLoad);
    document.addEventListener('shopify:block:load', onEditorLoad);
  })();
  } catch(e) { console.error(e); }
})();

})();
